// extracted by mini-css-extract-plugin
export default {"goBack":"goBack_goBack__kR-I-"};